import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import {
  Form,
  FormHeader,
  Button,
  ResultsCounter,
  Actions,
  ButtonSecondary,
  Table,
  CheckboxElement,
  withClassificationApi,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import ErrorNavigation from "../../../components/ErrorNavigation";

class CoursesClassificationsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClassifications: new Set(),
    };

    this.handleAddClassification = this.handleAddClassification.bind(this);
    this.handleSelectClassification =
      this.handleSelectClassification.bind(this);
    this.handleRemoveClassifications =
      this.handleRemoveClassifications.bind(this);
  }

  // componentDidMount() {
  //   if (this.props.location.hash) {
  //     this.props.handleScrollToElement(this.props.location.hash.substring(1));
  //   }
  // }

  // componentDidUpdate(prevProps) {
  //   if (this.props.location.hash !== prevProps.location.hash) {
  //     this.props.handleScrollToElement(this.props.location.hash.substring(1));
  //   }
  // }

  handleAddClassification(e) {
    e.preventDefault();

    let classifications = this.props.classifications;

    if (
      !classifications.some(
        (classification) => classification.id === this.props.classificationId
      )
    ) {
      this.props.classificationApiGetClassifications(
        [this.props.classificationId],
        i18n.language,
        (response) => {
          const classification = response.data[0];
          classifications.push(classification);
          this.props.handleSet({
            classifications: classifications,
            classificationId: "",
            classificationLabel: "",
          });
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  handleSelectClassification(e) {
    const selectedClassifications = this.state.selectedClassifications;
    const selectedClassificationId = e.target.value;

    if (selectedClassifications.has(selectedClassificationId)) {
      selectedClassifications.delete(selectedClassificationId);
    } else {
      selectedClassifications.add(selectedClassificationId);
    }

    this.setState(selectedClassifications);
  }

  handleRemoveClassifications(e) {
    e.preventDefault();

    const selectedClassifications = this.state.selectedClassifications;

    let classifications = this.props.classifications;

    classifications = classifications.filter(
      (classification) => !selectedClassifications.has(classification.id)
    );

    this.props.handleSet("classifications", classifications);

    selectedClassifications.clear();

    this.setState(selectedClassifications);
  }

  render() {
    return (
      <Form>
        <FormHeader
          title={this.props.t(
            "local:view.courses.create.tabs.classifications.title"
          )}
          introduction={this.props.t(
            "local:view.courses.create.tabs.classifications.introduction"
          )}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.t(
                "local:view.courses.create.tabs.classifications.mandatoryPrompt"
              ),
            }}
          />
        </FormHeader>
        <ErrorNavigation
          field={this.props.errorActiveField}
          handleClearActiveErrors={this.props.handleClearActiveErrors}
        />

        {/* Anchor element for navigating to when there are errors */}
        {this.props.classifications.length === 0 && (
          <div id={"classifications.1.id"} />
        )}

        {/* Add classification */}
        <AutocompleteTextfieldApiElement
          key={this.props["classificationLabel"]} // Force rerender to clear textfield after label changes.
          size={"large"}
          name={"classification"}
          label={this.props.t(
            "local:view.courses.create.tabs.classifications.field.addClassification.label"
          )}
          placeholder={this.props.t(
            "local:view.courses.create.tabs.classifications.field.addClassification.placeholder"
          )}
          description={this.props.t(
            "local:view.courses.create.tabs.classifications.field.addClassification.description"
          )}
          suffix={
            <Button
              classes={["button", "button--suffix", "button--style-blue"]}
              onClick={this.handleAddClassification}
              disabled={!this.props["classificationId"]}
            >
              {this.props.t(
                "local:view.courses.create.tabs.classifications.field.addClassification.callToAction"
              )}
            </Button>
          }
          hasButton={true}
          minimumCharacters={1}
          api={this.props.classificationApiGetEndpoint(
            "classification_api_classifications_mq"
          )}
          authorize={true}
          queryParameter={"search"}
          // additionalParameters={{
          //   "atlasAccountId": this.props.values.mainProviderId
          // }}
          keyField={"id"}
          valueField={"title"}
          dataFields={["id", "type", "title"]}
          keyword={this.props["classificationLabel"]}
          acceptLanguage={this.props.inputLanguage}
          value={this.props["classificationId"]}
          errors={this.props.errors["classifications.1.id"]}
          onChange={this.props.handleChange}
          required={true}
        />

        {this.props.classifications.length > 0 && (
          <Fragment>
            <ResultsCounter count={this.props.classifications.length}>
              <span>
                {this.props.t(
                  "local:view.courses.create.tabs.classifications.table.entity"
                )}
              </span>
              <Actions>
                <ButtonSecondary
                  classes={["button--large"]}
                  onClick={this.handleRemoveClassifications}
                >
                  {this.props.t(
                    "local:view.courses.create.tabs.classifications.table.control.remove"
                  )}
                </ButtonSecondary>
              </Actions>
            </ResultsCounter>

            <Table
              headers={[
                this.props.t(
                  "local:view.courses.create.tabs.classifications.table.header.select"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.classifications.table.header.referenceId"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.classifications.table.header.name"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.classifications.table.header.type"
                ),
              ]}
              rows={this.props.classifications.map((classification) => {
                return [
                  <CheckboxElement
                    checked={this.state.selectedClassifications.has(
                      classification.id
                    )}
                    value={classification.id}
                    onChange={this.handleSelectClassification}
                  />,
                  classification.id,
                  classification.title[this.props.inputLanguage],
                  classification.type,
                ];
              })}
            />
          </Fragment>
        )}
      </Form>
    );
  }
}

export default withClassificationApi(process.env)(
  withAssets(withTranslation("local")(CoursesClassificationsForm))
);
